import React, { useState } from "react";
import { Table, Button, Drawer, Form, Input, Space, message } from "antd";
import { adminService } from "../../../_services/admin.service";

const MultipleMobileAddress = (props) => {
  const [edit, setEdit] = useState(false);
  const [data, setData] = useState();
  const [form] = Form.useForm();

  const openEdit = (data1) => {
    setEdit(true);
    setData(data1);

    form.setFieldsValue({
      mobile: data1.mobile,
      address: data1.address,
    });
  };

  const closeEdit = () => {
    setEdit(false);
    setData(null);
    form.resetFields();
  };

  const onFinish = (values) => {
    const payload = {
      id: data.id,
      city: props.city,
      district: props.district,
      masterId: data.masterId,
      userId: props.userId,
      ...(props.mobile
        ? { mobile: values.mobile }
        : { address: values.address }),
    };

    setTimeout(() => {
      adminService.updateMobileAddress(payload).then((res) => {
        message.success("Updated Successfully");
        props.getMobileData(data.masterId);
      });
    }, 1200);

    closeEdit();
  };

  const columns = [
    {
      title: "Sr. No.",
      render: (text, record, index) => index + 1,
    },
    {
      title: props.mobile ? "Mobile Number" : "Address",
      dataIndex: props.mobile ? "mobile" : "address",
      ellipsis: true,
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space>
          <Button type="primary" onClick={() => openEdit(record)}>
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  let mobileData = props.data.filter((item) => item.mobile !== null);
  let addressData = props.data.filter((item) => item.address !== null);
  let tableData = props.mobile ? mobileData : addressData;

  return (
    <>
      <Table
        columns={columns}
        dataSource={tableData}
        rowKey={(record, index) => index}
        pagination={{ pageSize: 5 }}
      />

      <Drawer
        title={`Update ${props.mobile ? "Mobile" : "Address"}`}
        width={500}
        onClose={closeEdit}
        open={edit}
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          {props.mobile && (
            <Form.Item
              name="mobile"
              label="Mobile Number"
              rules={[
                { required: true, message: "Enter mobile number" },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Enter valid 10 digit mobile number",
                },
              ]}
            >
              <Input maxLength={10} />
            </Form.Item>
          )}

          {!props.mobile && (
            <Form.Item
              name="address"
              label="Address"
              rules={[{ required: true, message: "Enter address" }]}
            >
              <Input.TextArea rows={3} />
            </Form.Item>
          )}

          <Space>
            <Button onClick={closeEdit}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Space>
        </Form>
      </Drawer>
    </>
  );
};

export default MultipleMobileAddress;
